/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function() {
    $('#PRODUCT_ACTIVES').on('click', function() {
        $.magnificPopup.open({
            items: {
                src: $(this).data('url')
            },
            type: 'iframe',  // Loads the content in an iframe
            mainClass: 'mfp-fade',  // Animation and styling class
            removalDelay: 160,
            preloader: true,
            fixedContentPos: false
        });
    });
  
  function trackLastProductPage() {
    const currentPage = window.location.pathname;

    if (!currentPage.includes("/products/")) return;

    sessionStorage.setItem("mostRecentPage", currentPage);
  }

  function updateContinueShoppingLink() {
    document.querySelectorAll("[data-continue-shopping]").forEach((el) => {
      const recentPage = sessionStorage.getItem("mostRecentPage");
      if (recentPage) {
        el.href = recentPage;
      }
    });
  }

  trackLastProductPage();
  updateContinueShoppingLink();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches('[data-continue-shopping]')) {
              updateContinueShoppingLink();
            }
            const continueShoppingLinks = node.querySelectorAll('[data-continue-shopping]');
            if (continueShoppingLinks.length > 0) {
              updateContinueShoppingLink();
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

$(document).on('gtag.addItem', function(event, form) {
  const formData = new URLSearchParams(jQuery(form).serialize());
  const id = formData.get('id');
  const quantity = formData.get('quantity') ?? 1;

  const variantsJson = JSON.parse(document.querySelector("variant-radios [type='application/json']").textContent)
  const variant = variantsJson.find(v => v.id == id)

  gtag('event', 'conversion', {
      'send_to': 'AW-835757200/zphBCNCRm8EZEJDJwo4D',
      'value': variant.price / 100,             
      'currency': Shopify.currency.active
  });
});
